import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SiteShell from "../components/site/SiteShell";
import { Container, SectionHead, Button } from "../components/site/ui";
import { Reveal } from "../components/site/Reveal";
import { FinalCTA } from "./HomeNew";
import { CONCEPTS } from "../data/site";

export default function OurWork() {
  return (
    <SiteShell title="What We Can Build — Concept Websites | GoBuildWeb" description="Explore polished concept websites GoBuildWeb can build for auto, contractors, restaurants, retail, professional services and health & wellness businesses.">
      <section className="pt-[72px]">
        <Container className="py-16 text-center md:py-24">
          <Reveal>
            <SectionHead center eyebrow="What we can build" title="See what your business could look like" sub="We're just launching, so these are polished concept sites — clearly labeled — that show the quality we deliver. Your real project could be next." />
          </Reveal>
        </Container>
      </section>

      <section className="pb-16 md:pb-24">
        <Container>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {CONCEPTS.map((c, i) => (
              <Reveal key={c.slug} delay={(i % 3) * 0.07}>
                <Link to={`/what-we-can-build/${c.slug}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] transition-colors hover:border-gold-500/40" data-testid={`concept-${c.slug}`}>
                  <div className="relative aspect-[16/11] overflow-hidden">
                    <img src={c.img} alt={c.name} loading="lazy" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                    <span className="absolute left-3 top-3 rounded-full bg-black/70 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-gold-400 ring-1 ring-gold-500/40">{c.tag}</span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="text-xs text-gold-500">{c.industry}</div>
                    <h3 className="mt-1 font-display text-xl font-bold text-white">{c.name}</h3>
                    <p className="mt-2 flex-1 text-sm text-zinc-400">{c.description}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-white group-hover:text-gold-400">View concept <ArrowRight size={14} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
      <FinalCTA />
    </SiteShell>
  );
}
